import Compiler from './'

export default class Builder {
    constructor() {
        this.compiler = new Compiler()
    }

    async build(nodes) {
        let dist = {}

        for (let i = 0; i <= nodes.length; i++) {
            if (!nodes[i]) continue;
            const node = nodes[i]
            const path = node.name

            if (node.isLeaf) {
                let content = node.content || ''

                switch (nodes[i].ext) {
                    case 'vue':
                        dist[path] = await this.compiler.compileVue(null, content)
                        break
                    case 'js':
                        dist[path] = this.compiler.compileJS(content)
                        break;
                    case 'css':
                        dist[path] = await this.compiler.compileCSS(null, content)
                        break;
                    case 'svg':
                        dist[path] = this.compiler.transpileSVG(content)
                        break
                    case 'json':
                        dist[path] = content
                        break
                }
            } else {
                let d = await this.build(node.children || [])
                let remap = {}

                Object.keys(d).forEach(k => {
                    remap[`${path}/${k}`] = d[k]
                })

                dist = {
                    ...dist,
                    ...remap,
                }
            }
        }

        return dist
    }
}